// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__xeFA0","info":"UpdateTermsInfo_info__1J3qU"};